export default {
  "微信分享": {
    "标题": "中国技术力量",
    "介绍": "中国技术力量",
    "图片": "https://constatic.geekbang.org/infoq/5da3d9b45ce62.png?imageView2/0/w/800"
  },
  nav: {
    logoW: require('./assets/img/head-logo-w.png'),
    logo: require('./assets/img/head-logo.png'),
    navList: [
      {
        name: '数字基建',
        url: '#num'
      },
      {
        name: '开源创新',
        url: '#open'
      },
      {
        name: '业界资讯',
        url: '#news'
      },
      {
        name: '支持单位',
        url: '#support'
      }
    ]
  },
  banner: {
    pc: {
      url: require('./assets/img/banner.jpg'),
      link: 'https://www.infoq.cn',
      btnText: '数字基建·开源创新'
    },
    mobile: {
      url: require('./assets/img/mobilebg.png'),
      link: 'https://www.infoq.cn',
      btnText: '数字基建·开源创新'
    }
  },
  desc: [
    '经济发展新常态，全球科技产业竞争格局加剧，国内科技产业在技术引进与走出去的过程中都遇到了全新的挑战。下一步，激活创新要素，寻求科技自主自强，成为了业界关注的重点。',
    '特此，InfoQ 面向国内新一代信息技术领域技术中坚群体，InfoQ正式推出<span>「中国技术力量」</span>特别策划，目前我们将主要面向数字新基建以及开源赛道领域，发现并报道其中典型的<span>企业代表、行业领军人物，深度传播技术力量背后的人物故事，商业洞察，以及产业趋势。</span>'
  ],
  digital: {
    title: {
      title: '数字基建',
      subTitle: 'DIGITAL INFRASTRUCTURE'
    },
    personList: [
      {
        headUrl: require('./assets/img/person.png'),
        name: '孙元浩1',
        office: '星环科技创始人、CEO，2013年创办星环科技，致力于提供企业级容器云计算、大数据能核心',
        title: '国产基础软件崛起，要从消费端抓起',
        desc: '疫情导致全球经济与科技交流骤然减速的同时，国内新基建产业发展却被提速了不少。两会期间，新基建几乎成为了每一个参会人员必然提及的新概念；在34万亿政府型产业引导基金',
        link: 'https://www.infoq.cn'
      }
    ],
    videoList: [
      {
        img: require('./assets/img/video.png'),
        title: '星环科技CEO孙元浩：国产基础软件崛起，要从“消费端”抓起新基国产基础软件崛起',
        speaker: '孙元浩',
        office: '星环科技创始人、CEO，2013年创办星环科技',
        desc: '疫情导致全球经济与科技交流骤然减速的同时，国内新基建产业发展却被提速了不少。两会期间，新基建几乎成为了每一个参会人员必然提及的新概念；在34万亿政府型产业引导基金之下，腾讯、阿里等企业界巨擘也先后斥资押注，竞相看好。通过将大数据、云、人工智能等新兴的IT信息技术分别注入到电力、交通、5G通讯网络等通过将大数据、云、人工智能等新兴的IT信息技术分别注入到电力、交通、5G通讯网络等',
        link: 'www.infoq.cn'
      }
    ]
  },
  open: {
    title: {
      title: '开源创新',
      subTitle: 'DIGITAL INFRASTRUCTURE'
    },
    personList: [
      {
        headUrl: require('./assets/img/person.png'),
        name: '孙元浩',
        office: '星环科技创始人、CEO，2013年创办星环科技，致力于提供企业级容器云计算、大数据能核心',
        title: '国产基础软件崛起，要从消费端抓起',
        desc: '疫情导致全球经济与科技交流骤然减速的同时，国内新基建产业发展却被提速了不少。两会期间，新基建几乎成为了每一个参会人员必然提及的新概念；在34万亿政府型产业引导基金',
        link: ''
      }
    ],
    videoList: [
      {
        img: require('./assets/img/video.png'),
        title: '星环科技CEO孙元浩：国产基础软件崛起，要从“消费端”抓起新基国产基础软件崛起',
        speaker: '孙元浩',
        office: '星环科技创始人、CEO，2013年创办星环科技',
        desc: '疫情导致全球经济与科技交流骤然减速的同时，国内新基建产业发展却被提速了不少。两会期间，新基建几乎成为了每一个参会人员必然提及的新概念；在34万亿政府型产业引导基金之下，腾讯、阿里等企业界巨擘也先后斥资押注，竞相看好。通过将大数据、云、人工智能等新兴的IT信息技术分别注入到电力、交通、5G通讯网络等通过将大数据、云、人工智能等新兴的IT信息技术分别注入到电力、交通、5G通讯网络等',
        link: 'https://www.infoq.cn'
      }
    ]
  },
  news: {
    title: {
      title: '业界资讯',
      subTitle: 'DIGITAL INFRASTRUCTURE'
    },
    articleList: [
      {
        img: require('./assets/img/article.png'),
        type: '新基建领域',
        title: '星环科技CEO孙元浩：国产基础软件崛起，要',
        desc: '疫情导致全球经济与科技交流骤然减速的同时，国内新基建产业发展却被提速了不少。两会期间，新基建几乎成为了每一个参会人员必然提及的新概念；在34万亿政府型产业引导基金之下，腾讯、阿里等企业界巨擘也先后斥资押注，竞相看好。通过将大数据、云、人工智能等新兴的IT信息技术分别注入到电力、交通、5G通讯网络等通过将大数据、云、人工智能等新兴的IT信息技术分别注入到电力、交通、5G通讯网络等',
        link: 'https://www.infoq.cn'
      }
    ],
    btnTitle: '立即参与问卷调查',
    btnLink: 'https://www.infoq.cn'
  },
  support: {
    title: {
      title: '支持单位',
      subTitle: 'DIGITAL INFRASTRUCTURE'
    },
    partners: [
      {
        title: '战略合作伙伴',
        logoList: [
          {
            logoImg: require('./assets/img/logo.png'),
            link: ''
          }
        ]
      }
    ]
  }
}